import React from 'react'

import styles from "./styles/EmptyQuiz.module.scss"

import { Container } from 'react-bootstrap'
import { Button, DescriptionLight, Headline, SubHeader } from '../../Components/CustomComponent'
import { useNavigate } from 'react-router-dom'
import { baseRoute } from '../../Helper'
import { WEB_ROUTES } from '../../constants'

export default function EmptyQuiz({ data }) {
    const navigate = useNavigate()

    const handleBack = () => {
        navigate(baseRoute(WEB_ROUTES.QUIZ), {
            replace: true
        })
    }

    return (
        <Container className={styles.EmptyQuiz}>
            <div className={styles.coverImage}>
                <img
                    src={data.cover_image_url}
                    alt="Cover Image"
                    className={styles.image}
                />
            </div>
            <div className={styles.content}>
                <DescriptionLight
                    text={`${data.question_count || 0} Question(s)`}
                    size='55'
                />
                <Headline
                    text={data.title}
                    classes='mt-3 mb-4'
                />
                <SubHeader
                    text="No questions found in this quiz"
                    size='5'
                    classes='text-center my-5'
                />
            </div>
            <Button
                text='Back to home'
                classes='mt-auto'
                onClick={handleBack}
            />
        </Container>
    )
}
